// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import path from "path";
import * as _ from "lodash";
import * as React from "react";
import "./ApplicationSearchLayout.less";
import { ApplicationList } from "../ApplicationList";
import { ApplicationSearchCategory } from "./ApplicationSearchCategory";
import { ApplicationSearchResult } from "./ApplicationSearchResult";
import { getApplicationClassName, getClassName } from "../utils/className";
import { DomainService } from "../../entities/Domain";
import { ModuleService } from "../../entities/Module";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const className = getApplicationClassName("search", "layout");
export const ApplicationSearchLayout = props => {
  const {
    category,
    results,
    query
  } = props;
  const handleCategoryClick = React.useCallback(event => {
    event.preventDefault();
    event.stopPropagation();
  }, []);
  const [module] = ModuleService.queryModule(category?.module?.identifiant);
  const [domain] = DomainService.queryDomain(module?.domaine?.identifiant);
  return React.useMemo(() => /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ApplicationSearchCategory, {
      name: category?.name,
      code: domain?.code,
      count: _.size(results),
      onClick: handleCategoryClick
    }), /*#__PURE__*/_jsx(ApplicationList, {
      className: getClassName(className, domain?.code),
      items: _.map(results,
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      result => /*#__PURE__*/React.cloneElement(result, {
        as: ApplicationSearchResult,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        key: result.props.adresse,
        path: path.join(module.adresse, result.props.adresse),
        query
      })),
      virtualized: true
    })]
  }), [category, module?.adresse, domain?.code, results]);
};